// Phone Number aria-label
document.querySelectorAll('[href^="tel:"]').forEach(function(content){
  // Use current-aria label if one exists
  if(!content.getAttribute('aria-label')){
    let arialabel = content.innerHTML.replaceAll(/-|:/g, '.').split('');
    arialabel = arialabel.join(' ').replaceAll(' .', '.') + '.';
    content.setAttribute('aria-label', arialabel);
  }
});